//https://codepen.io/SahiljeetSingh/pen/qBNedNK

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import LocomotiveScroll from "locomotive-scroll";
import $ from "jquery";

gsap.registerPlugin(ScrollTrigger);

// if there are objects that may get inline styles added (like via tweens) that should get reverted, use ScrollTrigger.saveStyles() initially so that the current inline styles are saved for later reversion. It's not always necessary, but it goes well with ScrollTrigger.matchMedia() so we figured it'd make sense to show it here (it's not needed in this demo)
ScrollTrigger.saveStyles(".mobile, .desktop");

const locoScroll = new LocomotiveScroll({
  el: document.querySelector(".scrollContainer"),
  smooth: true,
  smartphone: {
    smooth: true,
  },
  tablet: {
    smooth: true,
  },
});

window.locoScroll = locoScroll;

// each time Locomotive Scroll updates, tell ScrollTrigger to update too (sync positioning)
locoScroll.on("scroll", ScrollTrigger.update);
var last_scroll_y = 0;
locoScroll.on("scroll", (e) => {
  if (e.scroll.y > 200 && !$('body').hasClass('page-id-7') || $('body').hasClass('page-id-7') && e.scroll.y > 3500) {
    if (e.scroll.y < last_scroll_y) {
      $("html").addClass("show-fixed-header");
    } else {
      $("html").removeClass("show-fixed-header");
    }
  } else {
    $("html").removeClass("show-fixed-header");
  }
  last_scroll_y = e.scroll.y;
});
// tell ScrollTrigger to use these proxy methods for the ".data-scroll-container" element since Locomotive Scroll is hijacking things
ScrollTrigger.scrollerProxy(".scrollContainer", {
  scrollTop(value) {
    return arguments.length
      ? locoScroll.scrollTo(value, 0, 0)
      : locoScroll.scroll.instance.scroll.y;
  }, // we don't have to define a scrollLeft because we're only scrolling vertically.
  getBoundingClientRect() {
    return {
      top: 0,
      left: 0,
      width: window.innerWidth,
      height: window.innerHeight,
    };
  },

  // LocomotiveScroll handles things completely differently on mobile devices - it doesn't even transform the container at all! So to get the correct behavior and avoid jitters, we should pin things with position: fixed on mobile. We sense it by checking to see if there's a transform applied to the container (the LocomotiveScroll-controlled element).
  pinType: document.querySelector(".scrollContainer").style.transform
    ? "transform"
    : "fixed",
});

// Page Home Talk US Animate
const btn_talk_us = document.querySelector(".btn-talk-us");

btn_talk_us &&
  gsap.to(".btn-talk-us", {
    scrollTrigger: {
      trigger: ".talk-to-us__block",
      start: "top center",
      end: "top center",
      scrub: true,
      once: true,
      scroller: ".scrollContainer",
      toggleClass: "inverse",
    },
  });

// Page Home Gallery Animate
function triggerOnlyDesktop() {
  gsap.utils.toArray(".scroll-photos__item").forEach((section, index) => {
    const w = document.querySelector(".home-gallery__block");
    let [x, y, xEnd, yEnd] = [0, 0, 0, 0];
    let scaleEnd,
      scrub = 1,
      scale = 1;
    if (index == 0 || index == 3)
      [x, y, xEnd, yEnd] = [
        0,
        0,
        ((w.scrollWidth - section.offsetWidth) / 2) * -1,
        "-20%",
      ];
    else if (index == 2 || index == 5)
      [x, y, xEnd, yEnd] = [
        0,
        0,
        (w.scrollWidth + section.offsetWidth) / 3,
        "-20%",
      ];
    else if (index == 1) {
      scrub = 1.5;
      [x, y, xEnd, yEnd] = [
        0,
        0,
        0,
        ((w.scrollWidth - section.offsetWidth) / 2) * -1,
      ];
    } else if (index == 4) {
      [x, y, xEnd, yEnd] = [
        0,
        0,
        0,
        ((w.scrollWidth - section.offsetWidth) / 3) * -1,
      ];
      scaleEnd = 1.5;
      var tl = gsap.timeline();

      tl.fromTo(
        section,
        { x, y, scale },
        {
          scale: scaleEnd,
          scrollTrigger: {
            trigger: w,
            scrub: 0.5,
            pin: false,
            scroller: ".scrollContainer",
            start: "65% +=30%",
            end: "+=200%",
          },
        }
      ).fromTo(
        $(section).children(".scroll-photos__photo"),
        {},
        {
          scale: scaleEnd * 1.5,
          scrollTrigger: {
            scrub: 1,
            trigger: document.querySelector(".illumination-block"),
            pin: false,
            start: "-=30% bottom",
            scroller: ".scrollContainer",
          },
        }
      );

      return;
    }

    gsap.fromTo(
      section,
      { x, y, scale },
      {
        scale: scaleEnd,
        x: xEnd,
        y: yEnd,
        scrollTrigger: {
          trigger: w,
          scrub,
          pin: true,
          scroller: ".scrollContainer",
          start: "65% +=30%",
          end: "+=200%",
        },
      }
    );
  });
}

if (window.innerWidth >= 1365 && !$('body').hasClass('page-id-9')) {
  triggerOnlyDesktop();
  $("[data-fancybox]").on("click", function () {
    return false;
  });
}

// Page Blog Animate
const blog_boxes = gsap.utils.toArray(".post__container");

blog_boxes.forEach((box) => {
  const anim = gsap.fromTo(
    box,
    { autoAlpha: 0, y: 50 },
    { duration: 1, autoAlpha: 1, y: 0 }
  );
  ScrollTrigger.create({
    trigger: box,
    animation: anim,
    toggleActions: "play none none none",
    once: true,
    scroller: ".scrollContainer",
    toggleClass: "v-viewed",
  });
});

// Page Gallery Animate
const boxes = gsap.utils.toArray(".gallery-preview");

boxes.forEach((box) => {
  const anim = gsap.fromTo(
    box,
    { autoAlpha: 0, y: 50 },
    { duration: 1, autoAlpha: 1, y: 0 }
  );
  ScrollTrigger.create({
    trigger: box,
    animation: anim,
    toggleActions: "play none none none",
    once: true,
    scroller: ".scrollContainer",
    toggleClass: "v-viewed",
  });
});

//  Site Data Attr Animate
const site_title = gsap.utils.toArray("[data-fade='fade-up']");

site_title.forEach((box) => {
  const anim = gsap.fromTo(
    box,
    { autoAlpha: 0, y: 100 },
    { duration: 1, autoAlpha: 1, y: 0 }
  );
  ScrollTrigger.create({
    trigger: box,
    animation: anim,
    start: "center bottom",
    toggleActions: "play none none none",
    once: true,
    scroller: ".scrollContainer",
    toggleClass: "v-viewed",
  });
});

// Page Technology Animate
const canvas = document.getElementById("hero-lightpass");
if (canvas) {
  const context = canvas.getContext("2d");
  canvas.width = themeVars["is_mobile"] ? 428 : 1280;
  canvas.height = themeVars["is_mobile"] ? 926 : 720;
  var can_width = themeVars["is_mobile"]
    ? $(window).width() > $(window).height()
      ? $(window).height()
      : $(window).width()
    : "75vw";//75vw
  var can_height = themeVars["is_mobile"] ? "100vh" : "calc(34vw)";//calc(100vw / 3.25)

  $(canvas).css({ width: can_width, height: can_height });
  var image_url = $("#hero-video__container").data("desktop-url");
  if (themeVars["is_mobile"]) {
    image_url = $("#hero-video__container").data("mobile-url");
  }
  const frameCount = 80;
  const currentFrame = (index) =>
    `${themeVars["public_url"]}/img/${image_url}/assembling${(index + 1)
      .toString()
      .padStart(2, "0")}.jpg`;

  const images = [];
  const airpods = {
    frame: 0,
  };

  for (let i = 0; i < frameCount; i++) {
    const img = new Image();
    img.src = currentFrame(i);
    images.push(img);
  }

  gsap.to(airpods, {
    frame: frameCount - 1,
    snap: "frame",
    //ease: "steps(" + frameCount + ")",
    scrollTrigger: {
      start: "42% center",
      scrub: true,
      pin: true,
      end: "=+350%",
      scroller: ".scrollContainer",
      trigger: "#animate__block",
      //scroller: '#scrollContainer',
    },
    onUpdate: render,
  });

  images[0].onload = render;
  // eslint-disable-next-line
  function render() {
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.drawImage(images[airpods.frame], 0, 0);
    if(airpods.frame >= 77) {
      $('.animate-block').addClass('view');
    } else {
      $('.animate-block').removeClass('view');
    }
  }
}

// Page Home Run text
gsap.utils.toArray(".tabs-slider__block").forEach((section) => {
  const w = section.querySelector(".repeater__list");
  let mobile = 5;
  if(themeVars.is_mobile) {
    mobile = 15;
  }
  const [x, xEnd] = ["0", (w.scrollWidth - section.offsetWidth) * -1];
  gsap.fromTo(
    w,
    { x },
    {
      x: xEnd / mobile,
      scrollTrigger: {
        trigger: section,
        scroller: ".scrollContainer",
        scrub: 0.4,
      },
    }
  );
});

window.addEventListener("load", function () {
  // each time the window updates, we should refresh ScrollTrigger and then update LocomotiveScroll.
  ScrollTrigger.addEventListener("refresh", () => locoScroll.update());

  // after everything is set up, refresh() ScrollTrigger and update LocomotiveScroll because padding may have been added for pinning, etc.
  ScrollTrigger.refresh();
  window.ScrollTrigger = ScrollTrigger;
});
